// eslint-disable-next-line no-restricted-imports
import { css } from "@emotion/react";

import { AspectRatios } from "../../image/src/index";

export type VidTypes = "mp4" | "mpeg" | "ogg" | "webm";

export interface AltSourceProps {
    videoLink: string;
    videoType?: VidTypes;
}

export interface VideoProps {
    videoLink: string;
    videoType?: VidTypes;
    videoPreviewImage?: string;
    loop?: boolean;
    muted?: boolean;
    aspectRatio?: AspectRatios;
    alternativeSources?: AltSourceProps[];
    className?: string;
}

const videoStyle = (aspectRatio?: AspectRatios) => {
    return css`
        max-width: 100%;
        ${aspectRatio
            ? `
        aspect-ratio: ${aspectRatio};
        object-fit: cover;
    `
            : ""}
    `;
};

export const Video = ({
    videoLink,
    videoType,
    videoPreviewImage,
    loop = true,
    muted = true,
    aspectRatio,
    alternativeSources,
    className
}: VideoProps) => {
    return (
        // eslint-disable-next-line jsx-a11y/media-has-caption
        <video
            playsInline={true}
            muted={muted}
            preload="auto"
            poster={videoPreviewImage}
            autoPlay={true}
            className={className}
            css={videoStyle(aspectRatio)}
            loop={loop}
        >
            <source
                src={videoLink}
                type={`video/${videoType ? videoType : "mp4"}`}
            />
            {alternativeSources
                ? alternativeSources.map((source: AltSourceProps, index) => {
                      return (
                          <source
                              key={index}
                              src={source.videoLink}
                              type={`video/${
                                  source.videoType ? source.videoType : "mp4"
                              }`}
                          />
                      );
                  })
                : null}
        </video>
    );
};
